export default {
  selected: null,
  hover: false,
  clicked: false,
  active: null,
  feature: null,
  event: null,
  download: null,
};
